export { default } from './SnackbarContent';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/SnackbarContent/index.js
// module id = 554
// module chunks = 121